module.exports = __webpack_public_path__ + "img/bsan.90b4823a.png";